// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --ds-checkbox-input-color: var(--ds-color-grey-10);
    --ds-checkbox-input-description-color: var(--ds-color-grey-20);
    --ds-checkbox-input-disabled-color: var(--ds-color-grey-30);
    --ds-checkbox-input-bg-color: var(--ds-color-grey-indigo-80);
    /* Border */
    --ds-checkbox-input-border-color: var(--ds-color-grey-indigo-60);
    --ds-checkbox-input-hover-border-color: var(--ds-color-grey-20);
    /* Outline */
    --ds-checkbox-input-outline-color: var(--ds-color-focus-outline);
    /* Input */
    --ds-checkbox-selected-fill: var(--ds-color-neon-0);
    --ds-checkbox-border-color: var(--ds-color-grey-40);
    --ds-checkbox-hover-border-color: var(--ds-color-grey-20);
    --ds-checkbox-selected-border-color: var(--ds-color-grey-10);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
